import { InvoiceEditPage } from "@/features/organization/invoice/pages/InvoiceEdit";

export const InvoiceEdit = () => {
  return <InvoiceEditPage />;
};
